var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconAnimationTimes = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M7.5,18.2c1.3-.7,3-.5,4,.5,1.7,1.7,2.7,6.1,2.7,6.1,0,0,.4-3.4.7-5.6s.6-3,1.2-4.5c1-2.4,4.7-5.2,6.8-4.6" }),
            React.createElement("path", { strokeWidth: 2, d: "M4.9,20.2h0" }),
            React.createElement("path", { strokeWidth: 2, d: "M2.4,24.4h0" }),
            React.createElement("path", { strokeWidth: 5, d: "M22.8,10h0" }),
            React.createElement("g", null,
                React.createElement("path", { d: "M26.6,17.4l-7.4,7.4" }),
                React.createElement("path", { d: "M26.6,24.8l-7.4-7.4" })))));
});
export default IconAnimationTimes;
//# sourceMappingURL=IconAnimationTimes.js.map